import React from "react";
import UploadSection from "./UploadSection";
import { subtitleEntryId } from "../../utils/subtitleEntryId";

type UploadStage = "idle" | "uploading" | "uploaded" | "error";

interface Props {
  files: File[];
  onChange: (files: File[]) => void;
  uploadStages: UploadStage[];
  progresses: number[];
  onCancel: () => void;
  onDeleteSubtitle: (index: number) => void;
  languages: string[];
  onLanguageChange: (index: number, language: string) => void;
  isEditingPublished?: boolean;
}

const SubtitlesUpload: React.FC<Props> = ({
  files,
  onChange,
  uploadStages,
  progresses,
  onCancel,
  onDeleteSubtitle,
  languages,
  onLanguageChange,
  isEditingPublished,
}) => {
  const handleFileChange = (file: File | null) => {
    if (file) {
      onChange([...files, file]);
    }
  };

  return (
    <div className="subtitles-upload-container">
      {/* Only one section title at the top */}
      <div className="upload-section-title">Subtitles</div>

      {/* Uploaded subtitle files, no title per file */}
      {files.map((file, index) => (
        <UploadSection
          key={subtitleEntryId(file)}
          title=""
          description=""
          formats=""
          onFileChange={() => {}}
          allowReplace={false}
          isEditingPublished={isEditingPublished}
          currentFile={file}
          uploadStage={uploadStages[index] || "idle"}
          progress={progresses[index] || 0}
          onCancel={onCancel}
          onDelete={() => onDeleteSubtitle(index)}
          language={languages[index] || ""}
          onLanguageChange={(lang) => onLanguageChange(index, lang)}
          showLanguageSelect={true}
        />
      ))}

      {/* New upload box with no title */}
      <UploadSection
        title=""
        description=""
        formats="Upload a subtitle file and select a language"
        onFileChange={handleFileChange}
        currentFile={null}
        accept=".srt,.vtt,.ass,.ssa,application/x-subrip,text/vtt"
        uploadStage="idle"
        progress={0}
        showLanguageSelect={false}
        isEditingPublished={isEditingPublished}
      />
    </div>
  );
};

export default SubtitlesUpload;
